export const checkQuantity = (quantity) => {
	return `Precio por ${quantity} unidad/es: $`;
};
